import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../theme/theme';

interface SimilarityRingProps {
  /** 0..1 */
  score: number;
  size?: number;
}

const SimilarityRing: React.FC<SimilarityRingProps> = ({ score, size = 38 }) => {
  const r = size / 2 - 3;
  const circumference = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(1, score));

  return (
    <Box sx={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#f1f1f4" strokeWidth={4} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={colors.primary}
          strokeWidth={4}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - pct)}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography sx={{ fontSize: 10, fontWeight: 800, color: colors.secondary }}>{Math.round(pct * 100)}%</Typography>
      </Box>
    </Box>
  );
};

export default SimilarityRing;
